import { mobileApiRequest } from '../../apiRequests'

// Action-plan candidates (recommended actions with accept/reject/create
// dispositions). Moved out of the retired plan system's API file — candidates
// are produced by investigation-group runs, not by plans.

export const listActionPlanCandidates = async (
    workspaceID,
    { sourceGroupId, scopeEntityId, includeRejected } = {}
) => {
    const action = {
        action: 'listActionPlanCandidates',
        workspaceID,
    }
    if (sourceGroupId) action.sourceGroupId = sourceGroupId
    if (scopeEntityId) action.scopeEntityId = scopeEntityId
    if (includeRejected != null) action.includeRejected = includeRejected
    return await mobileApiRequest(action)
}

export const acceptActionPlanCandidate = async (workspaceID, candidateFingerprint) => {
    const action = {
        action: 'acceptActionPlanCandidate',
        workspaceID,
        candidateFingerprint,
    }
    return await mobileApiRequest(action)
}

export const rejectActionPlanCandidate = async (workspaceID, { candidateFingerprint, reason }) => {
    const action = {
        action: 'rejectActionPlanCandidate',
        workspaceID,
        candidateFingerprint,
    }
    if (reason) action.reason = reason
    return await mobileApiRequest(action)
}

export const createActionPlanCandidate = async (workspaceID, candidate) => {
    const action = {
        action: 'createActionPlanCandidate',
        workspaceID,
        ...candidate,
    }
    return await mobileApiRequest(action)
}

// Context definitions listing (name, purpose, tier, spawn relationships) —
// generic config metadata, kept for group-config authoring and validation.
export const listContextDefinitions = async (workspaceID) => {
    const action = {
        action: 'listContextDefinitions',
        workspaceID,
    }
    return await mobileApiRequest(action)
}
